<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="dataTable.headers"
      :items="dataTable.items"
      :server-items-length="dataTable.itemsLength"
      :options.sync="dataTable.options"
      :footer-props="$config.dataTableFooterProps"
      calculate-widths
    >
      <template #[`item.user`]="{ item }">
        {{ item.user.name }}
      </template>
      <template #[`item.request_date`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <div v-on="on">{{ $moment(item.request_date).format('lll') }}</div>
          </template>
          <div>{{ $moment(item.request_date).format($config.momentFormats.explicit) }}</div>
        </v-tooltip>
      </template>
      <template #[`item.groups`]="{ item }">
        <v-chip-group>
          <v-chip
            small
            label
            link
            v-for="group in item.groups"
            :key="group.id"
            :color="group.color"
            :to="{ name: 'GroupEditor', params: { id: group.element_id } }"
            class="ma-1"
          >
            {{ group.name }}
          </v-chip>
        </v-chip-group>
      </template>
      <template #[`item.amount`]="{ item }">
        {{ item.email_sent_amount }} / {{ item.amount }}
      </template>
      <template #[`item.approved`]="{ item }">
        <span v-if="item.approved == 1" class="font-weight-bold success--text">Jóváhagyva</span>
        <span v-else class="font-weight-bold error--text">Nincs jóváhagyva</span>
      <!-- <v-icon v-if="item.approved == 1" color="success">mdi-checkbox-marked</v-icon>
      <v-icon v-else color="error">mdi-close-box</v-icon> -->
      </template>
      <template #[`item.approved_date`]="{ item }">
        <template v-if="item.approved == 1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <div v-on="on">{{ $moment(item.approved_date).format('lll') }}</div>
            </template>
            <div>{{ $moment(item.approved_date).format($config.momentFormats.explicit) }}</div>
          </v-tooltip>
        </template>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          v-if="item.approved == 0 && item.user_id == $store.state.user.element_id"
          @click="$emit('edit', item)"
          fab
          small
          color="primary"
          text
          class="rounded-sm m-1"
          title="Igénylés módosítása"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="item.approved == 1"
          title="Vonalkódok küldése"
          fab
          small
          color="primary"
          text
          class="rounded-sm m-1"
          :to="{ name: 'QrCodeRequestEditor', params: { id: item.id } }"
        >
          <v-icon>mdi-email-fast</v-icon>
        </v-btn>
        <v-btn
          v-if="item.approved == 0 && item.user_id == $store.state.user.element_id"
          @click="$emit('delete', item)"
          title="Igénylés törlése"
          fab
          small
          color="error"
          text
          class="rounded-sm m-1"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

  </div>
</template>

<script>
export default {
  name: "TabOwnRequests",

  props: {
    active: {
      type: Boolean,
      default: false,
    },
    fulfilled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      dataTable: {
        options: {
          sortBy: ['request_date'],
          sortDesc: [true],
        },
        headers: [
          { text: 'Igénylő', value: 'user', sortName: 'Users.name' },
          { text: 'Igénylés ideje', value: 'request_date', width: 128 },
          { text: 'Csoport', value: 'groups', sortable: false },
          { text: 'Mennyiség', value: 'amount' },
          { text: 'Megjegyzés', value: 'comment' },
          { text: 'Állapot', value: 'approved' },
          { text: 'Jováhagyás ideje', value: 'approved_date', width: 128  },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      requestDialog: {
        visible: false,
        requestId: null,
      },
    };
  },

  mounted() {
    this.fetchRequests();
  },

  methods: {
    async fetchRequests() {
      this.loading = true;
      try {
        const response = await this.$http.post(
          `qr-code-requests/list/${this.$store.state.user.element_id}`,
          {
            ...this.postData,
            fulfilled: this.fulfilled,
          }
        );
        this.dataTable.items = response.requests;
        this.dataTable.itemsLength = response.requests_count;
        this.dataTable.options.page = this.$route.query.page * 1 || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    async deleteRequest(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `Az igénylés törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.post(`qr-code-requests/delete/${item.id}`);
        this.fetchItems();
        if (response.status === 'OK') {
          this.$dialog.notify.info('Az igénylés törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },

    showRequestDialog(requestId = 0) {
      this.requestDialog.visible = true;
      this.requestDialog.requestId = request;
    },

    hideRequestDialog() {
      this.requestDialog.visible = false;
      this.requestDialog.requestId = null;
    },

    async requestDialogSaveEventHandler(request) {
      await this.fetchItems();
      this.dataTable.highlighted = [Number(request.id)];
    },
  },
};
</script>